/**
 * Created by Ning Jiang on 12/6/2018.
 */

import {BaseController} from "@nolimitcity/slot-game/bin/core/base/BaseController";
import {EventHandler} from "@nolimitcity/slot-game/bin/core/event/EventHandler";
import {GameEvent} from "@nolimitcity/slot-game/bin/core/event/GameEvent";
import {ScreenEvent} from "@nolimitcity/slot-game/bin/core/screen/event/ScreenEvent";
import {SlotGame} from "@nolimitcity/slot-game/bin/core/SlotGame";
import {SpinEvent} from "@nolimitcity/slot-game/bin/core/spin/event/SpinEvent";
import {TombstoneSoundConfig} from "../TombstoneSoundConfig";
import {ShootingGameView} from "./ShootingGameView";

export class ShootingGameController extends BaseController {

    private _view:ShootingGameView;
    private _shotLeft:number = 6;

    constructor() {
        super();
        this._view = new ShootingGameView((e:PIXI.InteractionEvent | undefined) => this.onClick(e));
        this.addEventListeners();
    }

    private addEventListeners():void {
        EventHandler.addEventListener(this, ScreenEvent.GAME_START, (event:GameEvent) => this.onGameStart());
    }

    private onGameStart() {
        EventHandler.addEventListener(this, SpinEvent.BEFORE_START, (event:GameEvent) => this.onBeforeSpinStart());
        EventHandler.addEventListener(this, ScreenEvent.PICK_AND_CLICK_START, (event:GameEvent) => this.onBeforeSpinStart());
        EventHandler.addEventListener(this, SpinEvent.IDLE, (event:GameEvent) => this.onEnableGame());
        this.onEnableGame();
    }

    public enable() {
        this.onEnableGame();
    }

    private onBeforeSpinStart():void {
        this.onDisableGame();
        this._shotLeft = 6;
    }

    private onEnableGame():void {
        // Logger.logDev("------------SHOOTING GAME ENABLED!");
        this._view.enabled = true;
    }

    private onDisableGame():void {
        // Logger.logDev("------------SHOOTING GAME DISABLED!");
        this._view.enabled = false;
        this._view.clear();
    }

    private onClick(e:PIXI.InteractionEvent |undefined):void {
        if(this._shotLeft > 0 && e != undefined) {
            this._view.shotAt(e.data.getLocalPosition(this._view.parent));
            SlotGame.sound.playEffect(TombstoneSoundConfig.instance.SHOOT_WINDOW);
            this._shotLeft--;

            //console.log("shot pos:", e.data.getLocalPosition(this._view.parent));

            e.stopPropagation();
        } else {
            SlotGame.sound.playEffect(TombstoneSoundConfig.instance.SHOOT_WINDOW_EMPTY);
        }


    }
}